module.exports = __webpack_public_path__ + "img/mid-console.e59adde7.png";